import { Instance, SnapshotOut, types } from 'mobx-state-tree';

/**
 * # MissionHistory
 *
 * 미션 히스토리 모델
 */
export const MissionHistory = types
  .model('MissionHistory')
  // --------------------------------------------------------------------------
  .props({
    target_week: types.string,
    prgs_rate: types.number,
    scen_cnt: types.number,
    prgs_scen_cnt: types.number,
    last_upd_dt: types.maybeNull(types.string),
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model missionHistory --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: any }) => {
      const newProps = { ...self, ...props } as IMissionHistory;
      (Object.keys(newProps) as TMissionHistoryKeys[]).forEach((key) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TMissionHistory = Instance<typeof MissionHistory>;
type TMissionHistorySnapshot = SnapshotOut<typeof MissionHistory>;

export interface IMissionHistory extends TMissionHistory {}
export type TMissionHistoryKeys = keyof TMissionHistorySnapshot & string;
export interface IMissionHistorySnapshot extends TMissionHistorySnapshot {}
export const createMissionHistory = () => types.optional(MissionHistory, {} as TMissionHistory);
